import _ from 'lodash'
import orderApi from '@/api/order'
import store from '@/store'
import form from './form'
import { generateFormHandlerMutations } from '@/helpers/forms'

const download = response => {
  const disposition = response.headers['content-disposition'] || ''
  const match = /filename\*?=(?:UTF-8'')?"?([^;"]+)"?/i.exec(disposition)
  const name = match ? decodeURIComponent(match[1]) : 'orders.csv'

  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }))
  const link = document.createElement('a')

  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    searchQuery: '',
    sortBy: '',
    sortDesc: false,
    restaurantIds: [],
    paymentMethodIds: [],
    dateFrom: null,
    dateTo: null,
  },
  exporting: false,
}

const getters = {
}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    orderApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
  },

  exportCsv({ commit }) {
    commit('EXPORT_STARTED')

    const { restaurantIds, paymentMethodIds, dateFrom, dateTo, searchQuery } = state.filters

    return orderApi.export({
 restaurantIds, paymentMethodIds, dateFrom, dateTo, searchQuery,
})
      .then(response => commit('EXPORT_FINISHED', response))
      .catch(error => {
        commit('EXPORT_FAILED')
        throw error
      })
  },
}

const mutations = {
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  EXPORT_STARTED(state) {
    state.exporting = true
  },
  EXPORT_FINISHED(state, response) {
    state.exporting = false
    download(response)
    store.dispatch('message/success', 'Файл готов')
  },
  EXPORT_FAILED(state) {
    state.exporting = false
    store.dispatch('message/error', 'Не удалось выгрузить заказы')
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
  form,
}

const watchers = [
  [state => state.order.filters, _.debounce(async () => await store.dispatch('order/fetchList'), 250), { immediate: false, deep: true }],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
